import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout, COMPANY } from "@/components/site/LegalLayout";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacystatement — Elvion Group Nederland" },
      { name: "description", content: "Privacystatement van Elvion Group Nederland: welke persoonsgegevens wij verwerken, met welk doel, hoe lang wij ze bewaren en welke rechten u heeft onder de AVG." },
      { property: "og:title", content: "Privacystatement — Elvion Group Nederland" },
      { property: "og:description", content: "Lees hoe Elvion Group Nederland zorgvuldig omgaat met uw persoonsgegevens conform de AVG: doelen, bewaartermijnen, beveiliging en uw rechten." },
      { name: "robots", content: "index,follow" },
      { property: "og:url", content: "https://elvion-group.nl/privacy" },
    ],
    links: [{ rel: "canonical", href: "https://elvion-group.nl/privacy" }],
  }),
  component: () => (
    <LegalLayout
      title="Privacystatement"
      intro={`${COMPANY.name} hecht veel waarde aan de bescherming van uw persoonsgegevens. In dit privacystatement geven wij heldere informatie over hoe wij omgaan met persoonsgegevens, conform de Algemene Verordening Gegevensbescherming (AVG).`}
    >
      <h2>1. Verwerkingsverantwoordelijke</h2>
      <p>{COMPANY.name}, gevestigd te {COMPANY.address}, {COMPANY.postal}, ingeschreven bij de Kamer van Koophandel onder nummer {COMPANY.kvk}, is verwerkingsverantwoordelijke.</p>

      <h2>2. Welke gegevens verwerken wij</h2>
      <ul>
        <li>NAW-gegevens (naam, adres, woonplaats)</li>
        <li>Contactgegevens (e-mailadres, telefoonnummer)</li>
        <li>Bestel- en betaalgegevens</li>
        <li>IP-adres en apparaatinformatie (analytics)</li>
        <li>Accountgegevens (bij aanmaken klantaccount)</li>
      </ul>

      <h2>3. Doeleinden van verwerking</h2>
      <ul>
        <li>Afhandeling van uw bestelling en betaling</li>
        <li>Levering van producten en diensten</li>
        <li>Klantenservice en garantieafhandeling</li>
        <li>Wettelijke verplichtingen (fiscaal, boekhouding)</li>
        <li>Verbetering van onze website en dienstverlening</li>
      </ul>

      <h2>4. Wettelijke grondslagen</h2>
      <p>Wij verwerken uw gegevens op basis van: uitvoering van een overeenkomst, wettelijke verplichting, gerechtvaardigd belang, of uw toestemming (bijv. nieuwsbrief).</p>

      <h2>5. Bewaartermijnen</h2>
      <p>Wij bewaren persoonsgegevens niet langer dan noodzakelijk. Voor bestelgegevens geldt de fiscale bewaartermijn van 7 jaar. Accountgegevens worden bewaard zolang uw account actief is.</p>

      <h2>6. Delen met derden</h2>
      <p>Wij verstrekken uw gegevens uitsluitend aan derden indien dit nodig is voor de uitvoering van onze overeenkomst (bijv. vervoerders, betaaldienstverleners) of om te voldoen aan een wettelijke verplichting. Met verwerkers sluiten wij verwerkersovereenkomsten.</p>

      <h2>7. Uw rechten</h2>
      <p>U heeft het recht op inzage, rectificatie, verwijdering (recht om vergeten te worden), beperking van de verwerking, dataportabiliteit en bezwaar tegen de verwerking, alsmede het recht om een eenmaal gegeven toestemming in te trekken. Stuur een verzoek naar {COMPANY.email}. Wij reageren binnen 4 weken.</p>
      <p>U heeft tevens het recht een klacht in te dienen bij de Autoriteit Persoonsgegevens: <a href="https://autoriteitpersoonsgegevens.nl" target="_blank" rel="noopener">autoriteitpersoonsgegevens.nl</a>.</p>

      <h2>8. Beveiliging</h2>
      <p>Wij nemen passende technische en organisatorische maatregelen (waaronder TLS-versleuteling, toegangscontrole en regelmatige beveiligingsupdates).</p>

      <h2>9. Beoordelingen - WebwinkelKeur</h2>
      <p>Wij verzamelen reviews via het platform van WebwinkelKeur. Als u een review achterlaat via WebwinkelKeur dan bent u verplicht om uw naam en e-mailadres op te geven. WebwinkelKeur deelt deze gegevens met ons, zodat wij de review aan uw bestelling kunnen koppelen. WebwinkelKeur publiceert uw naam eveneens op de eigen website. In sommige gevallen kan WebwinkelKeur contact met u opnemen om een toelichting op uw review te geven. In het geval dat wij u uitnodigen om een review achter te laten delen wij uw naam en e-mailadres met WebwinkelKeur. Zij gebruiken deze gegevens enkel met het doel u uit te nodigen om een review achter te laten. WebwinkelKeur heeft passende technische en organisatorische maatregelen genomen om uw persoonsgegevens te beschermen. WebwinkelKeur behoudt zich het recht voor om ten behoeve van het leveren van de dienstverlening derden in te schakelen, hiervoor hebben wij aan WebwinkelKeur toestemming gegeven. Alle hierboven genoemde waarborgen met betrekking tot de bescherming van uw persoonsgegevens zijn eveneens van toepassing op de onderdelen van de dienstverlening waarvoor WebwinkelKeur derden inschakelt.</p>

      <h2>10. Cookies</h2>
      <p>Zie ons <a href="/cookies">cookiestatement</a>.</p>

      <h2>11. Contact</h2>
      <p>Vragen over privacy? Neem contact op via {COMPANY.email} of {COMPANY.phone}.</p>
    </LegalLayout>
  ),
});
